import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.tsx';
import { DocumentStoreProvider } from './storage/index.ts';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Storage is local; a failed read is a real fault, not a flaky network.
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <DocumentStoreProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </DocumentStoreProvider>
    </QueryClientProvider>
  </StrictMode>,
);
